import React from "react";
import OpportunityEvaluation from "../OpportunityEvaluation";


class EvaluationTabNew extends React.Component {

    render() {

        return (
            <>
                <OpportunityEvaluation
                    opportunity={this.props.opportunity}
                />
            </>
        )
    }
}

export default EvaluationTabNew